import { InputSwitch } from "primereact/inputswitch";
import { useCategoryInfo } from "../../Hooks/Features/ProjectDashboard/useCategoryInfo";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { SkeletonContainer } from "../Loader/Loader";
import DatePicker from "react-multi-date-picker";


const CategoryInfo = () => {
    const { filterData, setFilterData, options, loader, chartData, GetProjectIssueTypeSummarData } = useCategoryInfo()

    return (
        <div className="w100" style={{ height: "100%" }}>
            <div className="card-container">
                <div className="d-flex gap-2 justify-content-between align-items-center mt-0">
                    <span style={{ fontSize: "14px", fontWeight: "600" }}> Project Category</span>
                    <div>
                        <label style={{ fontSize: "10px" }}>
                            <input type="radio" checked={filterData?.hierarchy === 0} onChange={(e) => setFilterData((prev) => ({ ...prev, hierarchy: 0, apiCall: true }))} />
                            H0
                        </label>
                        <label style={{ fontSize: "10px" }}>
                            <input type="radio" checked={filterData?.hierarchy === 1} onChange={(e) => setFilterData((prev) => ({ ...prev, hierarchy: 1, apiCall: true }))} />
                            H1
                        </label>
                    </div>
                    <div className="w30">
                        <DatePicker
                            value={""}
                            onChange={(e) => {
                                setFilterData((prev) => ({ ...prev, hoveredRange: e, isChange: true }))
                            }}
                            range
                            rangeHover
                            numberOfMonths={1}
                            placeholder="Select Dates"
                            onClose={() => {
                                if(filterData?.isChange) { GetProjectIssueTypeSummarData()} 
                            }}
                        />
                    </div>
                    <div className="stage-toggle custom-switch-wrapper">
                        <InputSwitch
                            inputId="stage-switch"
                            checked={filterData?.is_with_done}
                            onChange={(e) =>
                                setFilterData((prev) => ({ ...prev, is_with_done: e.value, apiCall: true }))
                            }
                        />
                        <span className={`switch-label ${filterData?.is_with_done ? 'on' : 'off'}`}>
                            Done
                        </span>
                    </div>
                </div>
                <div style={{ height: "90%" }}>
                    <div className="d-flex justify-content-center align-items-center" style={{ height: "95%" }}>
                        {
                            loader ? <div style={{ height: "inherit" }}>
                                <SkeletonContainer />
                            </div> : <>
                                {
                                    chartData?.length > 0 ?

                                        <HighchartsReact highcharts={Highcharts} options={options} containerProps={{
                                            style: {
                                                height: "inherit",
                                            },
                                        }} /> : <div className="w100 d-flex justify-content-center align-items-center" style={{ height: "inherit" }}>
                                            <div className='text-center'>
                                                <img src={"./assets/nodata.jpg"} alt='no data' />
                                                <p className=' red mt-3'> Data Not Found</p>
                                            </div>
                                        </div>
                                }
                            </>
                        }
                    </div>
                </div>

            </div>
        </div>

    )
}

export default CategoryInfo;